module.exports = __webpack_public_path__ + "static/media/ig8.511bf4e4.jpg";